var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ks-header"},[_c('div',{staticClass:"ks-header__box"},[_c('van-icon',{staticClass:"ks-header__i",attrs:{"name":"arrow-left"},on:{"click":_vm.rut}}),_vm._v(_vm._s(_vm.title)+"\n  ")],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0a8059e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ks-components/Header.vue
// module id = null
// module chunks = 